import Client from './Client'
import { Error } from './Error'

export default class Project extends Client {

  async fetchPages() {
    try {
      return await this.request('get', 'pages', null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async fetchPage(slug) {
    try {
      return await this.request('get', 'pages', null, { slug })
    } catch (error) {
      throw new Error(error)
    }
  }

  async fetchOptions() {
    try {
      return await this.request('get', 'options/module', null, null, true)
    } catch (error) {
      throw new Error(error)
    }
  }
}
